export default __webpack_public_path__ + "static/media/createPokemon.86f7a8a7.svg";